import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import upcoming1 from '../assets/images/Drops/upcoming-collection--collection-1.png';
import upcoming2 from '../assets/images/Drops/upcoming-collection--collection-2.png';
import upcoming3 from '../assets/images/Drops/upcoming-collection--collection-3.png';
import previous1 from '../assets/images/Drops/previous-collection--collection-1.png';
import previous2 from '../assets/images/Drops/previous-collection--collection-2.png';
import Header from './Header';

class Drops extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}
                
                {/* Breadcrum area start */}
                <div className="container-fluid drop text-center">
                    <div className="row">
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            <h1>Drops</h1>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, </p>
                        </div>
                        <div className="col-lg-2"></div>
                    </div>
                </div>
                {/* Breadcrum area end */}

                {/* Live Drop Content area start */}
                <div className="container drops-content margin-70">
                    <div className="text-center">
                        <h1>Friday August 2nd Drop is Live!</h1>
                    </div>
                    <div className="most-popular justify-content-center row">
                        <div className="card">
                            <div className="most-popular-card">
                                <Link to="/PrimaryMarket">
                                    <img src={previous2} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/PrimaryMarket">
                                        <h3>Many Faces Open Editions</h3>
                                        <h5>Disclosure</h5>
                                    </Link>
                                    <p className="card-text"><small>4 Exhibitions</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Live Drop Content area end */}

                {/* Upcoming Drop Content area start */}
                <div className="container drops-content margin-70">
                    <div className="text-center">
                        <h1>Saturday August 3rd Drop</h1>
                        <h4>Opens In 15 hours 4 minutes and 3 seconds</h4>
                    </div>
                    <div className="most-popular justify-content-center row">
                        <div className="card">
                            <div className="most-popular-card">
                                <Link to="/FutureCollection">
                                    <img src={upcoming1} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollection">
                                        <h3>Collection Title</h3>
                                        <h5>Artist Name</h5>
                                    </Link>
                                    <p className="card-text"><small>5 Exhibitions</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="most-popular-card">
                                <Link to="/FutureCollection">
                                    <img src={upcoming2} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollection">
                                        <h3>Digital Trip</h3>
                                        <h5>Okuda San Miguel</h5>
                                    </Link>
                                    <p className="card-text"><small>6 Exhibitions</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="most-popular-card">
                                <Link to="/FutureCollection">
                                    <img src={upcoming3} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/FutureCollection">
                                        <h3>Collection Title</h3>
                                        <h5>Artist Name</h5>
                                    </Link>
                                    <p className="card-text"><small>10 Exhibitions</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Upcoming Drop Content area end */}

                {/* Privious Drop Content area start */}
                <div className="container drops-content mb-5 margin-70">
                    <div className="text-center">
                        <h1>Thursday August 1st Drop</h1>
                    </div>
                    <div className="most-popular justify-content-center row">
                        <div className="card">
                            <div className="most-popular-card">
                                <Link to="/ClosedCollection">
                                    <img src={previous1} className="card-img-top" alt="" />
                                </Link>
                                <div className="card-body">
                                    <Link to="/ClosedCollection">
                                        <h3>DREAM LOGIC Open Editions with LOREM & ... MattAttack</h3>
                                        <h5>Duke Dumont</h5>
                                    </Link>
                                    <p className="card-text"><small>4 Exhibitions</small></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Privious Drop Content area end */}
            </div>
        )
    }
};

export default Drops;